import React, { useMemo, useState } from 'react';
import { Box, Container } from '@mui/material';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { KC_NAME } from '../../../constants/graphs';
import { ReduxState } from '../../../types';
import CustomHeader from '../../General/CustomHeader';
import Page from '../../Layout/Page';
import FullScreenChartShell from '../FullScreenChartShell/FullScreenChartShell';
import useStyles from '../styles';
import { generateBreadcrumb } from '../utils';
import KcChart from './KcChart';
import KcConfigContent from './KcConfigContent';
import { ModalState, EMPTY_MODAL_STATE } from '../chartModal';

const Kc = ({ fullScreen }: { fullScreen?: boolean }) => {
  const classes = useStyles();
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);

  const { selectedFarm } = useSelector((state: ReduxState) => state.accountFarm);
  const { selectedSector } = useSelector((state: ReduxState) => state.currentSector);

  const [modalState, setModalState] = useState<ModalState>(EMPTY_MODAL_STATE);
  const [conversationsRefreshCounter, setConversationsRefreshCounter] = useState(0);

  const farmId = queryParams.get('farmId') || '';
  const sectorId = queryParams.get('sectorId') || '';

  const breadcrumb = useMemo(() => generateBreadcrumb(
    selectedFarm, selectedSector, KC_NAME, sectorId,
  ), [selectedFarm, selectedSector]);

  if (fullScreen) {
    return (
      <FullScreenChartShell title="Coeficiente de cultivo">
        {(h) => (
          <KcChart
            chartView="fullScreen"
            sectorId={sectorId}
            farmId={farmId}
            externalModalState={modalState}
            hideXValues={false}
            height={`${h}px`}
            externalSetModalState={setModalState}
            onConversationCreated={() => setConversationsRefreshCounter((prev) => prev + 1)}
          />
        )}
      </FullScreenChartShell>
    );
  }

  return (
    <Page className={classes.root} title='Coeficiente de cultivo'>
      <Container maxWidth={false}>
        <CustomHeader title={breadcrumb} />
        <Box
          id="kc-chart-container"
          width={1}
          mb={3}
        >
          <KcChart
            chartView="settings"
            sectorId={sectorId}
            farmId={farmId}
            height={'250'}
            externalModalState={modalState}
            externalSetModalState={setModalState}
            onConversationCreated={() => setConversationsRefreshCounter((prev) => prev + 1)}
          />
        </Box>
        <KcConfigContent
          sectorId={sectorId}
          setModalState={setModalState}
          refreshCounter={conversationsRefreshCounter}
        />
      </Container>
    </Page>
  );
};

export default Kc;
